module.exports = __webpack_public_path__ + "img/etc1.e72b9a67.png";